import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styles from '../../../SearchWidget.module.scss';
import submitBtnImgPath from '../../../../../assets/media/submitIcon.svg';
import {connect} from "react-redux";
import {refBlur, refFocus} from "../../../../../tools/tools";
import animations from '../../../../../assets/scss/animations/animate.module.scss';
import shiftAware from "../../../../../hoc/ShiftAware/ShiftAware";
import moment from "moment";
import {isWellFilledLeg} from "../../../../../services/flightCourse/errors-controller";

const SubmitBtn = ({disabled, clickHandler, flightCourseState, commonState, contRef, prevRef, nextRef,
                       animationOnSubmit, multiCityMode, shiftPressed, inlineStyles, t, ...props}) => {

    const [animationClasses, setAnimationClasses] = useState('');

    const {userCardType, lang} = commonState;

    const {
        refreshing,
        roundTrip,
        adultsAmount,
        childrenAmount,
        infantsAmount,
        passengerType,
        promoCode,
        imagineMode,
        legs
    } = flightCourseState;

    const [firstLeg] = legs;
    const {origin, destination, dateStart, dateEnd} = firstLeg;

    const canSubmit = () => {
        if (!flightCourseState || refreshing) {
            return false;
        }

        const isRoundTrip = roundTrip === 'RETURN';
        const isOneWay = roundTrip === 'ONEWAY';
        const isMultiCity = roundTrip === 'MULTI';
        const isValidEndpoints = origin && destination;
        const isValidPax = !isNaN(adultsAmount) && !isNaN(childrenAmount) && !isNaN(infantsAmount) && passengerType;
        const canSubmitOneWay = (isOneWay && isValidEndpoints && isValidPax && dateStart);
        const canSubmitRoundTrip = (isRoundTrip && isValidEndpoints && isValidPax && dateStart && dateEnd);
        const canSubmitMultiCity = isMultiCity && isValidPax && legs.every(l => isWellFilledLeg(l));
        const canSubmitImagineMode = imagineMode && userCardType && !isMultiCity && (canSubmitOneWay || canSubmitRoundTrip);

        return ((!imagineMode && (canSubmitOneWay || canSubmitRoundTrip || canSubmitMultiCity)) || canSubmitImagineMode);
    };

    const keyDownHandler = e => {
        const code = e.code ? e.code : e.key;

        if (code === 'Tab' && shiftPressed) {
            refBlur(contRef);
            refFocus(prevRef);
            e.stopPropagation();
            e.preventDefault();
            return;
        }

        switch (code) {
            case 'Left':
            case 'ArrowLeft':
                refBlur(contRef);
                refFocus(prevRef);
                break;
            case 'Right':
            case 'ArrowRight':
            case 'Tab':
                refBlur(contRef);
                refFocus(nextRef);
                break;
            case 'Escape':
                refBlur(contRef);
                break;
            case ' ':
            case 'Space':
            case 'NumpadEnter':
            case 'Enter':
                clickHandlerLocal();
                break;
            default:
                return;
        }

        e.preventDefault();
        e.stopPropagation();
    };

    const formRef = React.createRef();

    const isDisabled = disabled || !canSubmit();
    const onClickHandler = isDisabled ? () => null : clickHandler ? clickHandler : () => formRef.current.submit();
    const classes = ['sw-hidden-on-shrink', styles.flightCourseSubmitBtnContainer];
    if (isDisabled) classes.push(styles.flightCourseSubmitBtnContainerDisabled);
    if (animationClasses) classes.push(animationClasses);

    const clickHandlerLocal = () => {
        if (!isDisabled) {
            if (!animationOnSubmit) {
                return onClickHandler();
            }

            setAnimationClasses([animations.animated, animations.bounceOutRight].join(' '));
            setTimeout(() => setAnimationClasses(''),600);
            onClickHandler();
        }
    };

    const letsFlyForm = () => {

        if (!canSubmit()) {
            return '';
        }

        const isOneWay = roundTrip === 'ONEWAY';

        return <form method={'POST'}
                     action={`${process.env.REACT_APP_SUBMIT_URL}?lang=${lang.substring(0,2)}`}
                     /*target={'_blank'}*/
                     ref={formRef}>
            <input type={'hidden'} name={'action'} value={'flightSearch'}/>
            <input type={'hidden'} name={'flightType'} value={imagineMode && userCardType ? (isOneWay ? 'ONEWAY_AWARD' : 'RETURN_AWARD') : roundTrip}/>
            <input type={'hidden'} name={'origin'} value={origin.code}/>
            <input type={'hidden'} name={'destination'} value={destination.code}/>
            <input type={'hidden'} name={'outboundDate'} value={dateStart.format('YYYY-MM-DD')}/>
            <input type={'hidden'} name={'inboundDate'} value={roundTrip === 'RETURN'
                ? dateEnd.format('YYYY-MM-DD') : dateStart.format('YYYY-MM-DD')}/>
            <input type={'hidden'} name={'paxType'} value={passengerType}/>
            <input type={'hidden'} name={'numADT'} value={adultsAmount}/>
            <input type={'hidden'} name={'numCHD'} value={childrenAmount}/>
            <input type={'hidden'} name={'numINF'} value={infantsAmount}/>
            <input type={'hidden'} name={'utm_source'} value={'sataazores_PT'}/>
            <input type={'hidden'} name={'utm_medium'} value={'referral'}/>
            <input type={'hidden'} name={'utm_campaign'} value={'home_page_nav'}/>
            <label className={'sr-only'} htmlFor={'promoCode'}>{t('Promotion code')}</label>
            <input type={'hidden'} id={'promoCode'} name={'promoCode'} value={promoCode}/>
            {legs.map((l, idx) => ([
                <input key={`origin${idx}`} type={'hidden'} name={`origin${idx}`}
                       value={l.origin ? l.origin.code : ''}/>,
                <input key={`destination${idx}`} type={'hidden'} name={`destination${idx}`}
                       value={l.destination ? l.destination.code : ''}/>,
                <input key={`flightDate${idx}`} type={'hidden'} name={`flightDate${idx}`}
                       value={l.dateStart instanceof moment ? l.dateStart.format('YYYY-MM-DD') : ''}/>
            ]))}
        </form>;
    };

    return (
        <div onClick={clickHandlerLocal}
             ref={contRef}
             onKeyDown={keyDownHandler}
             className={classes.join(' ')}
             style={inlineStyles}
             role={'button'}
             tabIndex={0}>
            {letsFlyForm()}
            <img src={submitBtnImgPath} alt={'submit btn'}/>
        </div>
    );
};

SubmitBtn.propTypes = {
    inlineStyles: PropTypes.object,
    clickHandler: PropTypes.func,
    disabled: PropTypes.bool,
    flightCourseState: PropTypes.object,
    commonState: PropTypes.object,
    animationOnSubmit: PropTypes.bool,
    multiCityMode: PropTypes.bool,
    contRef: PropTypes.any,
    prevRef: PropTypes.any,
    nextRef: PropTypes.any,
    t: PropTypes.func,
};

SubmitBtn.defaultProps = {
    inlineStyles: {},
    clickHandler: null,
    disabled: false,
    flightCourseState: {},
    commonState: {},
    animationOnSubmit: false,
    multiCityMode: false,
    contRef: null,
    prevRef: null,
    nextRef: null,
    t: s => s,
};

export default connect(state => ({commonState: state.common, flightCourseState: state.flightCourse}))(shiftAware(SubmitBtn));
